// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getMinutes as fn } from "../getMinutes.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getMinutesWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getMinutesWithOptions;
